import Mutations from '../../odata/mutations';

export default { ...new Mutations('stage'), ...new Mutations('stages') };
